import { v4 as uuid } from "uuid";

const init = (name) => ({ id: uuid(), name, points: 0, photo: null });

const name = (player, name) => ({ ...player, name });
const photo = (player, photo) => ({ ...player, photo });

const Player = { init, name, photo };
export default Player;
